import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Makes external/refreshed hash links (e.g. /residential/panel-upgrades#pricing)
 * scroll to the right section once React has finished rendering it.
 */
const HashScrollHandler = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) return;
    const id = decodeURIComponent(hash.replace("#", ""));
    if (!id) return;

    let frame = 0;
    let attempts = 0;

    const tryScroll = () => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "auto", block: "start" });
        // Re-assert once more after late-loading content (images, fonts) shifts layout
        window.setTimeout(() => {
          document.getElementById(id)?.scrollIntoView({ behavior: "auto", block: "start" });
        }, 400);
        return;
      }
      if (attempts++ < 60) {
        frame = window.requestAnimationFrame(tryScroll);
      }
    };

    frame = window.requestAnimationFrame(tryScroll);
    return () => window.cancelAnimationFrame(frame);
  }, [pathname, hash]);

  return null;
};

export default HashScrollHandler;
